module.exports = __webpack_public_path__ + "static/media/icon-hsd-target-circle.b8fb10cf.svg";